import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const markBoundaryCursorPluginKey: PluginKey = new PluginKey('markBoundaryCursorPlugin');
